import styled from 'styled-components'

import { MEDIA_QUERY } from '../../../../../styles'

export const InputColumns = styled('div').withConfig({
  shouldForwardProp: (prop) => !['columns'].includes(prop)
})<{ columns: number }>`
  display: grid;
  grid-template-columns: repeat(${({ columns }) => columns}, auto);
  align-items: center;
  @media ${MEDIA_QUERY.MOBILE} {
    grid-template-columns: 1fr;
    justify-content: center;
    gap: 30px;
  }
`
